import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Button, Title } from '@cognite/cogs.js';
import { Modal } from 'antd';

export const DeleteItemDialog = ({
  itemType,
  onClose,
  onDelete,
  actionType,
}: {
  itemType?: string;
  onClose: VoidFunction;
  onDelete: VoidFunction;
  actionType: string;
}) => {
  const [loading, setLoading] = useState(false);

  const deleteItem = async () => {
    setLoading(true);
    try {
      await onDelete();
    } finally {
      onClose();
    }
  };

  return (
    <Modal visible footer={null} onCancel={onClose}>
      <Title level={4} style={{ marginBottom: '1.5rem' }}>
        {`${actionType} ${itemType}`}
      </Title>
      <StyledLabel>{`Are you sure you want to ${actionType.toLowerCase()} this ${itemType}?`}</StyledLabel>
      <StyledButtons>
        <Button type="ghost" onClick={onClose} style={{ marginRight: '1rem' }}>
          Cancel
        </Button>
        <Button
          type="primary"
          loading={loading}
          onClick={(e) => {
            e.stopPropagation();
            deleteItem();
          }}
        >
          {`Yes, ${actionType.toLowerCase()} ${itemType} `}
        </Button>
      </StyledButtons>
    </Modal>
  );
};

const StyledButtons = styled.div`
  padding: 2rem 0 0 0;
  text-align: right;
`;

const StyledLabel = styled.p`
  font-family: Inter;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  margin: 0.5rem 0.2rem;
`;
